import pdf from 'vue-pdf'
import axios from 'axios'
import { Toast } from 'vant'
import { getSharePage, generateCourseNewAttachmentUrl } from '@/api'
export default {
  components: { pdf },
  props: [],
  name: 'pdf-view',
  data () {
    return {
      openPdf: false,
      courseId: null,
      pdfTotal: null,
      pdfLoading: false,
      pdfNow: 1,
      pdfUrl: '',
      pdfname: '',
      c: null
    }
  },
  computed: {
    // x: function() {}
  },
  watch: {
    // x: function(val) {}
  },
  created () {
    const { url, title, desc } = this.$route.query
    this.pdfUrl = url
    this.pdfname = title
    this.setWXShareInfo(title, desc)
  },
  mounted () {
    this.initData()
  },
  destroyed () {},
  methods: {
    async initData () {
      this.loading = true
      const { data } = await getSharePage(this.$route.query.courseId, this.$route.query.qrcode === 'true')
      this.course = data
    },
    pdfload (pdfTotal) {
      this.pdfTotal = pdfTotal
    },
    lastPage () {
      if (this.pdfNow > 1) { this.pdfNow-- }
    },
    nextPage () {
      if (this.pdfNow < this.pdfTotal) { this.pdfNow++ }
    },
    async setWXShareInfo (title, desc) {
      const currentRouter = this.$router.currentRoute.fullPath
      const basehref = `https://sou-m.gecacademy.cn${currentRouter}`
      const shareTitle = title
      const shareDesc = desc
      const shareImgUrl = 'https://gecacademy.oss-cn-beijing.aliyuncs.com/oa/smallSearch/share/share.jpeg'
      const shareInfo = {
        title: shareTitle,
        desc: shareDesc,
        link: basehref,
        imgUrl: shareImgUrl,
        success () { },
        cancel () { }
      }
      const timestamp = parseInt(new Date() / 1000)
      const params = { timestamp, noncestr: 'test', url: encodeURIComponent(basehref), appName: 'gecFuwuhao' }
      const result = await axios.get('https://api.gecacademy.cn/pay/wx/signature', { params })
      const signature = result.data.data
      const wx = this.$wx
      await wx.configAsync({
        debug: false,
        appId: 'wxac72a16e964c725f',
        timestamp,
        nonceStr: 'test',
        signature,
        jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'chooseImage',
          'previewImage',
          'uploadImage',
          'chooseWXPay'
        ]
      })
      wx.onMenuShareTimeline(shareInfo)
      wx.onMenuShareAppMessage(shareInfo)
    },
    async downloadFile () {
      const loading = Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      const { data } = await generateCourseNewAttachmentUrl({ schoolBegins: this.course.schoolBegins, teacherName: this.course.teacherName, fileName: this.pdfname, url: this.pdfUrl })
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = data.newUrl
      a.click()
      loading.clear()
    }
  }
}
